import React from "react";
import { useIntl } from "react-intl";
import { PeekStack, PeekTypography } from "@piiqtechnologies/ui-components";
import messages from "./messages.i18n";
export var ERROR_CODES;
(function (ERROR_CODES) {
    ERROR_CODES["INACTIVE"] = "user_inactive";
    ERROR_CODES["PENDING_APPROVAL"] = "sso_pending_access";
    ERROR_CODES["PAGE_NOT_FOUND"] = "page_not_fount";
    ERROR_CODES["INTERNAL_ERROR"] = "internal_error";
})(ERROR_CODES || (ERROR_CODES = {}));
const getErrorMessages = (errorCode) => {
    const intl = useIntl();
    let errorTitle = messages.loginInvalidUserErrorTitle;
    let errorMessage = messages.loginInvalidUserErrorMessage;
    switch (errorCode) {
        case ERROR_CODES.INACTIVE: {
            errorTitle = messages.loginInactiveUserErrorTitle;
            errorMessage = messages.contactAdmin;
            break;
        }
        case ERROR_CODES.PENDING_APPROVAL: {
            errorTitle = messages.loginPendingApprovalError;
            errorMessage = messages.contactAdmin;
            break;
        }
        case ERROR_CODES.PAGE_NOT_FOUND: {
            errorTitle = messages.pageNotFoundError;
            errorMessage = messages.contactAdmin;
            break;
        }
        case ERROR_CODES.INTERNAL_ERROR: {
            errorTitle = messages.internalServerError;
            errorMessage = messages.contactAdmin;
            break;
        }
    }
    return { errorTitle: intl.formatMessage(errorTitle), errorMessage: intl.formatMessage(errorMessage) };
};
export const Error = ({ errorCode }) => {
    const { errorMessage, errorTitle } = getErrorMessages(errorCode);
    return (React.createElement(PeekStack, { spacing: 2.5 },
        errorCode !== ERROR_CODES.INACTIVE && errorCode !== ERROR_CODES.PENDING_APPROVAL && (React.createElement("img", { src: "/images/sadparrot.gif", width: 27, height: 35, alt: "Error" })),
        React.createElement(PeekStack, { spacing: 1 },
            React.createElement(PeekTypography, { variant: "body1", fontWeight: "fontWeightBold" }, errorTitle),
            React.createElement(PeekTypography, { variant: "body1" }, errorMessage))));
};
export default Error;
